export default __webpack_public_path__ + "static/flowersBouquet-5827d6d703535ea57022ecb3813ec76d.png";